module.exports = __webpack_public_path__ + "img/antes_despues_191.227f9260.png";